import { Link, useMatch, useResolvedPath } from "react-router-dom";

function CustomLink({ children, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <Link
      className="browse-event"
      style={{
        color: match && "#f16334",
        textDecoration: "none",
        fontWeight: match && 600,
      }}
      to={to}
      {...props}
    >
      {children}
    </Link>
  );
}
export default CustomLink;
